import {
  useSensors,
  useSensor,
  MouseSensor,
  TouchSensor,
  KeyboardSensor,
  type DragEndEvent,
} from '@dnd-kit/core';
import { arrayMove, sortableKeyboardCoordinates } from '@dnd-kit/sortable';
import { ColumnOrderState } from '@tanstack/react-table';

/**
 * Custom hook for handling drag and drop functionality in the table
 */
export function useDragAndDrop(
  columnOrder: ColumnOrderState,
  setColumnOrder: (order: ColumnOrderState | ((prev: ColumnOrderState) => ColumnOrderState)) => void
) {
  const sensors = useSensors(
    useSensor(MouseSensor, {
      activationConstraint: {
        distance: 10,
      },
    }),
    useSensor(TouchSensor, {
      activationConstraint: {
        delay: 250,
        tolerance: 5,
      },
    }),
    useSensor(KeyboardSensor, {
      coordinateGetter: sortableKeyboardCoordinates,
    })
  );

  const handleDragEnd = (event: DragEndEvent) => {
    const { active, over } = event;
    if (active && over && active.id !== over.id) {
      setColumnOrder(colOrder => {
        const oldIndex = colOrder.indexOf(active.id as string);
        const newIndex = colOrder.indexOf(over.id as string);
        return arrayMove(colOrder, oldIndex, newIndex);
      });
    }
  };

  return {
    sensors,
    handleDragEnd,
  };
}
